import { request } from '@api/request'
import { PersonalizedGroupDTO } from '@models/api/PersonalizedGroupDTO'
import { AxiosResponse } from 'axios'

export const personalizedGroup = {
  getPersonalizedGroups: function (): Promise<
    AxiosResponse<PersonalizedGroupDTO[]>
  > {
    return request.get('variables/personalizedGroups')
  },

  getFirePersonalizedGroups: function (): Promise<
    AxiosResponse<PersonalizedGroupDTO[]>
  > {
    return request.get('variables/personalizedWildFireGroups')
  }
}
